
<div v-if="userId" class="ui dropdown profileMenu">
  <a class="profileMenu__userMenuIcon">
    <i class="fas fa-user-circle"></i>
    <span
      class="profileMenu__userMenuBadge"
      v-show="$root.unreadNotifications.length > 0">
    </span>
  </a>
  <div class="left large menu">
    <a class="item" href="/notifications">通知<span v-show="$root.unreadNotifications.length > 0" class="ui red circular label profileMenu__notificationBadge">{{ $root.unreadNotifications.length }}</span></a>
    <a class="item" href="/member/settings">ユーザー情報変更</a>
    <a class="item" href="/chats">チャット一覧</a>
    <div class="divider"></div>
    <div class="item" @click="logout">ログアウト</div>
  </div>
</div>
